/**
 * Alta y edición de fundo (reescrito en JSX legible el 2026-10-07): además del
 * nombre, la sede a la que pertenece (Ica / Pisco). Fundos es el único maestro:
 * el bot de Transporte ofrece estos mismos fundos como «sedes».
 */
import {
  rec_Lo as claseEntrada,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as clasePrimario,
  rec_api as api,
  rec_ii as IconoCarga,
  rec_zo as claseSecundario,
} from "../../runtime/index.jsx";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useEffect = (...a) => React.useEffect(...a);
const useState = (...a) => React.useState(...a);

export function FormularioFundo({ editar, onClose, onGuardado }) {
  const [nombre, setNombre] = useState(editar?.nombre ?? ``);
  const [sedeId, setSedeId] = useState(editar?.sedeId ?? ``);
  const [sedes, setSedes] = useState([]);
  const [error, setError] = useState(``);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    api(`/sedes`).then((l) => {
      const activas = (l ?? []).filter((s) => s.activo);
      setSedes(activas);
      if (!editar?.sedeId) {
        const ica = activas.find((s) => s.nombre?.toUpperCase() === `ICA`);
        if (ica) setSedeId(ica.id);
      }
    }).catch(() => setSedes([]));
  }, []);

  async function guardar(e) {
    e.preventDefault();
    if (guardando) return;
    setGuardando(true);
    setError(``);
    try {
      const body = JSON.stringify({ nombre, activo: !editar || editar.activo, sedeId: sedeId || null });
      if (editar) await api(`/fundos/${editar.id}`, { method: `PUT`, body });
      else await api(`/fundos`, { method: `POST`, body });
      onGuardado();
    } catch (x) {
      setError(x.message);
      setGuardando(false);
    }
  }

  return (
    <Modal titulo={editar ? `Editar fundo` : `Nuevo fundo`} onClose={onClose}>
      <form onSubmit={guardar} className="flex flex-col gap-3">
        <input className={claseEntrada} placeholder="Nombre del fundo" value={nombre} onChange={(e) => setNombre(e.target.value.toUpperCase())} required autoFocus />
        <label className="flex flex-col gap-1 text-sm text-(--text)">
          Sede
          <select className={claseEntrada} value={sedeId} onChange={(e) => setSedeId(e.target.value)} required>
            <option value="" disabled>Elige la sede</option>
            {sedes.map((s) => <option key={s.id} value={s.id}>{s.nombre}</option>)}
          </select>
          <span className="text-xs">El bot de Transporte ofrece este fundo con los destinos de su sede.</span>
        </label>
        {error && <p className="text-sm text-(--error)">{error}</p>}
        <div className="mt-2 flex justify-end gap-2">
          <button type="button" onClick={onClose} className={claseSecundario}>Cancelar</button>
          <button type="submit" disabled={guardando} className={clasePrimario}>
            {guardando && <IconoCarga className="mr-1 inline h-4 w-4 animate-spin" />}
            {editar ? `Guardar` : `Crear`}
          </button>
        </div>
      </form>
    </Modal>
  );
}
